import { useSettingsDrawer } from './SettingsDrawerContext';

export function BurgerMenu() {
  const { isOpen, open, close } = useSettingsDrawer();

  function toggleMenu() {
    if (isOpen) close();
    else open();
  }

  return (
    <div className="burger-menu-shell">
      <button
        type="button"
        className="burger-menu"
        onClick={toggleMenu}
        aria-label="Open settings"
        aria-expanded={isOpen}
        aria-haspopup="dialog"
      >
        <span className="burger-menu-icon" aria-hidden="true">
          ⚙︎
        </span>
      </button>
    </div>
  );
}
